import { UseFormSetValue } from 'react-hook-form'
import { ComboboxItem } from '@node-space/ui-components'
import { stripSpecialCharacters } from 'pages/Contacts/utils/utils'
import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

interface UseMoveFormHandlersProps {
  customerOptions?: ComboboxItem[]
  setValue: UseFormSetValue<MovePayload>
  transferWalletOptions?: ComboboxItem[]
  setSearchQuery: (query: string) => void
  setWalletNameSearch: (query: string) => void
  validateAmount: (amount: string) => void
}

export const useMoveFormHandlers = ({
  setValue,
  validateAmount,
  customerOptions,
  transferWalletOptions,
  setSearchQuery,
  setWalletNameSearch,
}: UseMoveFormHandlersProps) => {
  const handleWalletTransferTypeSelection = (walletTransferType: WalletTransferType) => {
    setValue('customerReference', '')
    setValue('destinationCustomerName', '')
    setValue('destinationWallet', '')
    setValue('destinationWalletName', '')
    setValue('walletTransferType', walletTransferType)
  }

  const handleCustomerSelection = (customerReference: string) => {
    const selectedCustomer = customerOptions?.find(
      customer => customer?.value === customerReference
    )
    setValue('destinationCustomerName', (selectedCustomer?.leftText as string) || '')
    setValue('customerReference', customerReference)
  }

  const handleDestinationWalletSelection = (walletReference: string) => {
    const selectedWallet = transferWalletOptions?.find(wallet => wallet?.value === walletReference)
    setValue('destinationWalletName', (selectedWallet?.leftText as string) || '')
    setValue('destinationWallet', walletReference)
    setWalletNameSearch('')
  }

  const handleSearchQueryChange = (value: string) => {
    setSearchQuery(stripSpecialCharacters(value))
  }

  const handleDestinationWalletSearchChange = (value: string) => {
    setValue('destinationWallet', '')
    setValue('destinationWalletName', '')
    setWalletNameSearch(stripSpecialCharacters(value))
  }

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('amount', e.target.value)
  }

  const handleAmountBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    validateAmount(e.target.value)
  }

  const handlePaymentReferenceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('paymentReference', e.target.value)
  }

  return {
    handleAmountBlur,
    handleAmountChange,
    handleCustomerSelection,
    handleDestinationWalletSelection,
    handleDestinationWalletSearchChange,
    handlePaymentReferenceChange,
    handleSearchQueryChange,
    handleWalletTransferTypeSelection,
  }
}
